import { AlphabetizedMap } from '../utils/EntityMap';

let { _,x,b,c,d,e,f,g,h,i,j,k,l,m } = AlphabetizedMap;
/* 
    b=flame=red
    c=N=blue
    d=coin=green
    e=star=yellow
    f=solidBlack=purple
    g=moon=skyBlue
    h=heart=orange
    i=triangle=pink
    j=blank=white
    k=grey=grey
    l=special=rainbow
    m=block=gold
*/

export default [
    [f,f,0,0,0,0,0,0,0,0,0,0,0,0,0,k,k],
     [j,i,i,j,j,j,j,j,j,j,j,j,j,e,e,j,_],
    [0,0,c,b,b,c,c,c,c,c,c,c,b,b,c,0,0],
     [0,0,0,j,e,e,j,j,j,j,i,i,j,0,0,0,_],
    [0,0,0,0,0,c,k,k,c,f,f,c,0,0,0,0,0],
     [0,0,0,0,0,0,j,h,h,j,0,0,0,0,0,0,_],
    [0,0,0,0,0,0,0,0,c,0,0,0,0,0,0,0,0],
     [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,_],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
     [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,_],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
     [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,_],
    [x,x,x,x,x,x,x,x,x,x,x,x,x,x,x,x,x]
];